import EditItemModal from 'components/Modals/EditItemModal';
import ModelType from 'components/Model/ModelType';
import { hasValidInput } from 'components/Model/ModelUtils';
import { useTranslation } from 'localization/useTranslation';
import _ from 'lodash';
import { useState, useMemo } from 'react';
import React from 'react';
import { privileges } from 'utils/types';
import { useOrgIdSelect } from 'components/Select/useOrgIdSelect';


const defaultGroup = {
  displayName: '',
  description: ''
};


const NewGroupDialog = ({ isOpen, onSave, onCancel }) => {
  const [group, setGroup] = useState(null);
  const T = useTranslation();
  const { currentOrg } = useOrgIdSelect({ onChange: null, neededPrivilege: privileges.UserManagement });


  const model = useMemo(() => {
    return [
      {
        type: ModelType.TEXT,
        // TODO: translate
        label: 'Display Name',
        path: 'displayName',
        isRequired: true,
        hasError: _.isEmpty
      },
      {
        type: ModelType.TEXTAREA,
        // TODO: translate
        label: 'Description',
        path: 'description'
      },
      {
        type: ModelType.ORG_ID,
        label: T.common.organization,
        path: 'organization',
        properties: {
          neededPrivilege: privileges.UserManagement
        }
      }];
  }, [T.common.organization]);


  const _onSave = (group) => {
    setGroup(defaultGroup);
    onSave(group);
  };

  const _onCancel = () => {
    setGroup(defaultGroup);
    onCancel();
  };

  return (
    <>
      <EditItemModal
        isOpen={isOpen}
        // TODO: translate
        title={T.organization.group.create.title}
        saveEnabled={hasValidInput(group, model)}
        onSave={_onSave}
        onCancel={_onCancel}
        item={group ?? { ...defaultGroup, organization: currentOrg }}
        setItem={setGroup}
        models={model}
      />
    </>
  );
};

export default NewGroupDialog;
